import { IEvent, IEventAggregationService, ISubscriber } from "@studyportals/event-aggregation-service-interface";

export class EventAggregationService implements IEventAggregationService {
	public static readonly instance: IEventAggregationService = new EventAggregationService();

	public subscribeTo(eventType: string, subscriber: ISubscriber<IEvent>, replay?: boolean | undefined): void {
		if (window["EventAggregationService"]) {
			(window["EventAggregationService"] as EventAggregationService).subscribeTo(eventType, subscriber, replay);
		}
	}

	public publishTo(eventType: string, event: IEvent): void {
		if (window["EventAggregationService"]) {
			(window["EventAggregationService"] as EventAggregationService).publishTo(eventType, event);
		}
	}
}
